import Vue from 'vue'

import { store } from './_store';
import { router } from './_helpers';
import App from './app/App';

import Config from './_config/config';
Vue.use(Config);


//import { Datetime } from 'vue-datetime';
//import 'vue-datetime/dist/vue-datetime.css'

//import '../build/pwa-auth.js';
import '@pwabuilder/pwaauth'; 


//Vue.component('datetime', Datetime);


import VueSocialSharing from 'vue-social-sharing'
Vue.use(VueSocialSharing);

//import socketio from 'socket.io-client';
//import VueSocketIO from 'vue-socket.io'

//import '@/api/feathers-client'
import './registerServiceWorker'
//import Breabcrumbs from 'vue-2-breadcrumbs'


//Vue.http.options.xhr = {withCredentials: true};

Vue.config.productionTip = false

/*
Vue.use(new VueSocketIO({
    debug: true,
    connection: 'kkshop.uber.space',
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    },
    options: { path: "/api" } // Optional options
}))
*/

new Vue({
  el: '#app',
  router,
  store,
  //Breabcrumbs,
//  datetime:Datetime,
  render: h => h(App)
});//.$mount('#app')
